import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  forwardRef,
  Input,
  OnChanges,
  Output,
  SimpleChanges
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { PRESET_COLORS } from '@bixi/core/internal';
import { OnChangeType, OnTouchedType } from 'ng-zorro-antd/core/types';
import { DEFAULT_COLOR } from './color-panel.component';
import { IAnyColor, IColorMode } from './color-picker.type';

@Component({
  selector: 'bixi-color-picker',
  exportAs: 'bixiColorPicker',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => BixiColorPickerComponent),
      multi: true
    }
  ],
  host: {
    '[class.bixi-color-picker]': 'true'
  },
  template: `
    <div
      class="bixi-color-picker-trigger"
      [class.bixi-color-picker-trigger-lg]="size ===  'large'"
      [class.bixi-color-picker-trigger-sm]="size ===  'small'"
      [class.bixi-color-picker-trigger-disabled]="disabled"
      nz-popover
      [(nzPopoverVisible)]="visible"
      nzPopoverOverlayClassName="bixi-color-picker-popover-overlay"
      (nzPopoverVisibleChange)="onVisibleChange($event)"
      [nzPopoverTrigger]="disabled ? null : 'click'"
      nzPopoverPlacement="bottomLeft"
      [nzPopoverContent]="popoverContent"
    >
      <bixi-color-block
        class="bixi-color-picker-trigger-inner"
        [color]="color">
      </bixi-color-block>
    </div>
    <ng-template #popoverContent>
      <bixi-color-panel
        [mode]="mode"
        [color]="color"
        [alphaDisabled]="alphaDisabled"
        [presetColors]="presetColors"
        [borderless]="true"
        (colorChange)="onColorChange($event)"
      >
      </bixi-color-panel>
    </ng-template>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BixiColorPickerComponent implements OnChanges {
  color: IAnyColor;
  visible = false;

  @Input() mode: IColorMode = 'hex';
  @Input() size: 'large' | 'small' | 'default' = 'default';
  @Input() disabled = false;
  @Input() alphaDisabled = false;
  @Input() presetColors: string[] = PRESET_COLORS;
  @Input() borderless = false;
  @Output() openChange = new EventEmitter();

  constructor(private cdr: ChangeDetectorRef) { }

  ngOnChanges(changes: SimpleChanges) {
    const { disabled } = changes;
    if (disabled && this.disabled) {
      this.visible = false;
    }
  }
  onChange: OnChangeType = () => { };
  onTouched: OnTouchedType = () => { };

  writeValue(color: IAnyColor): void {
    if (this.color === color) return;
    this.color = color || DEFAULT_COLOR;
    this.cdr.markForCheck();
  }

  registerOnChange(fn: OnChangeType): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: OnTouchedType): void {
    this.onTouched = fn;
  }

  onVisibleChange(visible: boolean) {
    this.openChange.emit(visible);
  }

  onColorChange(color: IAnyColor) {
    this.color = color;
    this.onChange(color);
    this.cdr.markForCheck();
  }
}
